import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useEffect, useRef, useState } from 'react';
import copyTextToClipboard from './clipboardUtils';
var RESET_DELAY_MS = {
  copied: 1500,
  failed: 3000
};

// Shared copy-to-clipboard behavior for function components: manages the
// idle/copied/failed status and its auto-reset timer around clipboardUtils.
function useCopyToClipboard() {
  var _useState = useState('idle'),
    _useState2 = _slicedToArray(_useState, 2),
    status = _useState2[0],
    setStatus = _useState2[1];
  var timerRef = useRef(null);
  useEffect(function () {
    return function () {
      return clearTimeout(timerRef.current);
    };
  }, []);
  var copy = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(text) {
      var success;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return copyTextToClipboard(text);
          case 2:
            success = _context.sent;
            setStatus(success ? 'copied' : 'failed');
            clearTimeout(timerRef.current);
            timerRef.current = setTimeout(function () {
              setStatus('idle');
            }, success ? RESET_DELAY_MS.copied : RESET_DELAY_MS.failed);
            return _context.abrupt("return", success);
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function copy(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  return [status, copy];
}
export default useCopyToClipboard;